import "react-app-polyfill/ie9";

import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import {
  applyPolyfills,
  defineCustomElements,
} from "@meios-pagamentos/eldorado-bridge-component/loader";

import { ThemeProvider } from "styled-components";
import App from "./components/App";
import history from "./history";
import store from "./store";
import { initMonitoring, setSentryMsisdn } from "./monitoring";

import { STYLES, GlobalFonts, GlobalStyle } from "./styles/_utilities";
import "./index.scss";

initMonitoring();

// Marca o msisdn do usuário logado no Sentry/GlitchTip a cada mudança no store.
let currentMsisdn;
store.subscribe(() => {
  const msisdn = store.getState().rechargeState?.newRecharge?.targetMsisdn;
  if (msisdn !== currentMsisdn) {
    currentMsisdn = msisdn;
    setSentryMsisdn(msisdn);
  }
});

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={STYLES}>
      <App history={history} />
      <GlobalFonts />
      <GlobalStyle />
    </ThemeProvider>
  </Provider>,
  document.getElementById("app-root")
);

applyPolyfills().then(() => {
  defineCustomElements();
});
